import React from "react";
import "./styles.scss";

const ProductDescription = (props) => {
  const { bundle_description, data } = props;
  return (
    <div className="description-container">
      <p className="bundle">{bundle_description}</p>
      <p className="bundle">You can remove products from the bundle.</p>

      {data?.map((item, index) => {
        return (
          <div key={index} className="section">
            <div className="image">
              <img src={item?.icon} alt={`risk area icon${index}`} />
            </div>
            <h3>{item?.title}</h3>
            <p dangerouslySetInnerHTML={{ __html: item?.description }} />
          </div>
        );
      })}
    </div>
  );
};

export default ProductDescription;
